const COPY_BODY_HTML_DEBUG_KEY = 'F8';

/**
 * Registra un atajo de teclado para copiar `document.body.outerHTML` al portapapeles.
 * Solo debe activarse en desarrollo.
 *
 * @returns Función de limpieza que elimina el listener.
 */
export function installCopyBodyHtmlDebugShortcut(): () => void {
  const onKeyDown = async (event: KeyboardEvent): Promise<void> => {
    if (event.key !== COPY_BODY_HTML_DEBUG_KEY) {
      return;
    }

    event.preventDefault();

    try {
      await navigator.clipboard.writeText(document.body.outerHTML);
      console.info('[debug] Body copiado al portapapeles');
    } catch (error) {
      console.error('[debug] Error al copiar body:', error);
    }
  };

  document.addEventListener('keydown', onKeyDown);
  return () => document.removeEventListener('keydown', onKeyDown);
}
